import * as React from "react";
import { useState } from "react";
import { Survey, getSurveyStatus } from "../../../../../../../amorg-common";
import { generateSurveyAnswers } from "../../../../../../../api/surveyClientApi";
import { Button } from "../../../../../../../designSystem/button/Button";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { TextField } from "../../../../../../../designSystem/formField/text/TextField";
import { Modal } from "../../../../../../../designSystem/Modal";

type GenerateAnswersModalProps = {
    show:boolean,
    survey:Survey,
    disabled?:boolean,
    onUpdated:() => void,
    onClose:()=>void
};
export const GenerateAnswersModal = (props:GenerateAnswersModalProps): JSX.Element => {
    return (
        <Modal 
                title={"Opret test besvarelser"}
                content={props.show &&
                    <GenerateAnswersPanel 
                         survey={props.survey} 
                         onClickCancel={() => props.onClose()}
                         onCreated={() => {
                             props.onUpdated();
                             props.onClose();
                         }} 
                     />
                }
                showModal={props.show}
                onCancel={() => props.onClose()}/>
    );
};

type GenerateAnswersPanelProps = {
    survey:Survey,
    onCreated:() => void,
    onClickCancel:() => void
}
function GenerateAnswersPanel(props:GenerateAnswersPanelProps): JSX.Element
{
    const [amount, setAmount] = useState('10');

    function parseAmount() {
        return Number.parseInt(amount)
    }

    function isAmountValid(){
        const val = parseAmount();
        if(isNaN(val))
            return false;
        
        return val >= 0 && val <= 1000;
    }

    async function handleClickGenerate()
    {
        if(canSubmit){
            const result = await generateSurveyAnswers(
                props.survey.id,
                parseAmount()
            );
            if(result.isSuccess)
                props.onCreated();
        }
    }

    const canSubmit = isAmountValid() && 
        getSurveyStatus(props.survey).canSubmitAnswer;

    return (
        <Flex flexDirection="column" gap={16}>
            
            <TextField
                value={amount} 
                onChange={value => setAmount(value)}
                label={`Antal besvarelser`} 
                validator={() => { 
                    return isAmountValid()
                        ? {valid:true}
                        : {valid:false, errorMessage:'Ugyldig værdi. Skal være et helt tal mellem 0 og 1000'}}
                } 
            />
            
            <Flex flexDirection="row" justifyContent="space-between">
                <Button variant="text"
                    text="Annuller"
                    onClick={props.onClickCancel} />

                <Button variant="filled"
                    text="Opret"
                    disabled={!canSubmit}
                    onClick={handleClickGenerate} />
            </Flex>
        </Flex>
    );
}
